import { StatusChip } from 'common/components/display/StatusChip';
import { isDevEnv } from 'common/utils/common';
import React from 'react';
import Stripe from 'stripe';

interface Props {
	account: Stripe.Account;
}

export const StripeStatus = ({ account }: Props) => {
	const detailsSubmitted = account.details_submitted;
	const chargesEnabled =
		account.charges_enabled === undefined ? false : account.charges_enabled || isDevEnv();

	return (
		<StatusChip
			title="Status"
			variant={!detailsSubmitted ? 'warning' : !chargesEnabled ? 'error' : 'success'}
			text={!detailsSubmitted ? 'Pending' : !chargesEnabled ? 'Inactive' : 'Active'}
		/>
	);
};
